import React from 'react';
import { NativeSyntheticEvent, TextInput, TextInputChangeEventData } from 'react-native';
import Text, { textVariantStyleMap } from '../Text';
import Stack from '../Stack';
import { containerLayout } from './InputBase';

export type LargeTextInputInputOwnProps = {
    placeholder: string;
    error?: string;
    value: string | null;
    onChange: (e: NativeSyntheticEvent<TextInputChangeEventData>) => void;
    onBlur?: () => void;
    onFocus?: () => void;
    isDisabled?: boolean;
    testID?: string;
    /** Stops input at the limit, so a server-side ceiling on the same field is never reached by ordinary typing. */
    maxLength?: number;
};

export type LargeTextInputInputProps = LargeTextInputInputOwnProps;

const LargeTextInputInput: React.FC<LargeTextInputInputProps> = (props) => {
    return (
        <Stack vertical fullWidth align="flex-start" flex={1}>
            <TextInput
                style={{
                    flex: 1,
                    width: '100%',
                    borderColor: 'transparent',
                    ...containerLayout,
                    ...({ outlineStyle: 'none' } as any),
                    ...textVariantStyleMap[props.value ? 'note-content-value' : 'note-content-placeholder'],
                }}
                placeholder={props.placeholder}
                value={props.value || ''}
                onChange={props.onChange}
                multiline
                maxLength={props.maxLength}
                testID={props.testID}
                textAlignVertical="top"
            />
            {props.error ? <Text variant="input-error">{props.error}</Text> : null}
        </Stack>
    );
};

export default React.memo(LargeTextInputInput);
